<template>
  <v-flex xs12>
    <div style="display: flex; align-items: center">
      <h6 class="body-1 font-weight-bold lightblue--text mr-4">
        Importância Segurada
      </h6>
      <v-switch
        color="lightblue"
        :value="isEnabled"
        @change="$emit('toggle-section', 'is')"
      />
    </div>
    <v-layout row wrap v-if="isEnabled">
      <v-flex xs3>
        <v-text-field
          label="Modalidade Principal"
          class="form-select-box"
          placeholder="Selecionar"
          :value="modality"
          disabled
        />
      </v-flex>
      <v-flex xs3>
        <v-text-field
          class="jns-input"
          label="Nova Importância Segurada"
          v-money="moneyConfig"
          v-model.lazy="valorImportanciaSegurada"
          :rules="importanciaSeguradaRules"
          @change="hasIsInputFocused = true"
          @blur="hasIsInputFocused = true"
          @input="updateImportancia"
          placeholder=""
          autofocus
        />
      </v-flex>
      <v-flex xs3>
        <v-menu
          lazy
          v-model="isDatePickerOpen"
          transition="scale-transition"
          offset-y
          full-width
          :close-on-content-click="false"
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            class="jns-input jns-datepicker"
            label="Início de Vigência do Endosso (A partir de)"
            :value="inicioVigencia"
            append-icon="event"
            placeholder="00/00/00"
            :rules="vigenciaRules"
            :disabled="disableVigenciaInput"
          />
          <v-date-picker
            :value="inicioVigenciaISO"
            @input="updateInicioVigenciaIS"
            @change="isDatePickerOpen = false"
            no-title
            scrollable
            actions
            :rules="vigenciaRules"
          />
        </v-menu>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script lang="js">
import { VMoney } from "v-money";
import {
  vigencyMustStartAfterCurrent,
  isISValueChanged,
  validateISGreaterThanApoliceIS,
} from "@/libs/endorsement";
import { inputCurrencyTextToFloat } from "@/libs/money";

export default {
  name: "ImportanciaSegurada",
  props: { policy:Object, model: Object },
  directives: { money: VMoney },
  data() {
    return {
      moneyConfig: {},
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " ",
        precision: 2,
      },
      isDatePickerOpen: false,
      valorImportanciaSegurada: 0.0,
      hasIsInputFocused: false,
    };
  },
  beforeMount() {
    this.moneyConfig = this.$settings.moneyConfig;
  },

  watch: {
    model: {
      handler: function (val, _oldVal) {
        if (val) this.valorImportanciaSegurada = this.prepareIsValue(val.valor);
      },
    },
  },
  computed: {
    disableVigenciaInput() {
      // NOTE: if the component is disabled,
      // it doesn't run the `validation rules`.
      // so we toggle on/off just to make it run...
      return !this.isDatePickerOpen;
    },
    isEnabled() {
      return Boolean(this.model);
    },
    modality() {
      return this.policy.modalidades.principal;
    },
    inicioVigencia() {
      return this.model.inicio_vigencia?.format("L");
    },
    inicioVigenciaISO() {
      // NOTE: this function is to satisfy v-date-picker.
      return this.model.inicio_vigencia?.format(this.model.inicio_vigencia._f);
    },
    vigenciaRules() {
      const self = this;
      const a = "Início da vigência da importância segurada deve ser definida.";
      const b = "Início da vigência da importância segurada deve ser após o início atual.";
      return [
        (v => Boolean(v) || a),
        (() => self.model.inicio_vigencia && vigencyMustStartAfterCurrent(self.policy, self.model.inicio_vigencia) || b)
      ];
    },
    importanciaSeguradaRules() {
      const self = this;
      const a = "Importância segurada deve ser definida.";
      const b = "Importância segurada não pode ser a mesma.";
      const c = "Importância segurada deve ser maior que R$ 0,00.";
      const d = "Importância segurada deve ser maior que a original.";
      if (!self.hasIsInputFocused) return [];
      return [
        (v => Boolean(v) || a),
        (v => isISValueChanged(self.policy, inputCurrencyTextToFloat(v))  || b),
        (v => inputCurrencyTextToFloat(v) > 0 || c),
        (v => validateISGreaterThanApoliceIS(self.policy, inputCurrencyTextToFloat(v)) || d)

      ];
    }
  },
  methods: {
    updateImportancia(value) {
      this.$emit("update-is", inputCurrencyTextToFloat(value));
    },
    updateInicioVigenciaIS(value) {
      this.$emit("update-inicio-vigencia-is", value);
    },
    prepareIsValue(value) {
      return Number.isInteger(value) ? value + ",00" : value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/ImportanciaSegurada.vue